import { EnvConfig } from '@core';
import { firebaseStageCredentials } from '../secrets/firebase-stage';

const DOMAIN = 'stage-app.split-zero.com';
const IOS_APP_ID = '6771158105';

export const environment = {
  environment: 'stage',
  production: false,
  apiUrl: 'https://stage-api.split-zero.com',
  frontendUrl: `https://${DOMAIN}`,
  domain: DOMAIN,
  firebase: firebaseStageCredentials,
  androidApkUrl: 'https://cdn.split-zero.com/android-apk/app-release.apk',
  iOSApkUrl: `https://apps.apple.com/app/id${IOS_APP_ID}`,
  sentryDsn: '',
  unleash: {
    url: 'https://flags.split-zero.com/api/frontend',
    clientKey: '*:development.1e4119adc2c926595c815dabb0f7e17b5100062075d71495f47c11dd75dd4ed5',
    appName: 'split-zero-web'
  }
} as const satisfies EnvConfig;
